module.exports = __webpack_public_path__ + "static/media/burger-soda.140a56cc.svg";